import genSelectors from '../core/selectors';
import { MODEL } from '../core/reducer';
import { CONTACT_MODEL } from './reducer';

export default genSelectors([MODEL, CONTACT_MODEL]);
